import { ButtonInputWithPopover } from "@msys/ui";
import { Box } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { OrganisationMembersSelect } from "../../organisations/OrganisationMembersSelect.js";

export function TasksAssigneeFilterButton({
  value,
  setValue,
}: {
  value: string[] | undefined;
  setValue: (newValue: string[] | undefined) => void;
}) {
  const { t } = useTranslate(["Tasks"]);

  return (
    <ButtonInputWithPopover
      label={t("Assignee", { ns: "Tasks" })}
      counter={value?.length || undefined}
      content={
        <Box p={1}>
          <OrganisationMembersSelect
            inputLabel={t("Assignee", { ns: "Tasks" })}
            sorting={[{ column: "firstname", direction: "asc" }]}
            filters={{ statuses: ["ACTIVATED"] }}
            value={value ?? []}
            onChange={newValue => {
              const nextValue =
                newValue && newValue.length > 0 ? newValue : undefined;
              setValue(nextValue);
            }}
          />
        </Box>
      }
      popoverWidth="md"
    />
  );
}
